<template>
  <div class="col-12 col-lg-9 mt-4 mt-lg-0">
    <div class="card">
      <div class="card-header">
        <h5>Order History</h5>
      </div>
      <div class="card-divider"></div>
      <div class="card-table">
        <div class="table-responsive-md">
          <table>
            <thead>
              <tr>
                <th>Order</th>
                <th>Date</th>
                <th>Status</th>
                <th>Total</th>
                <th>Tracking</th>
                <th>Download</th>
              </tr>
            </thead>
            <tbody>
              <order-history-line
                v-for="order in displayedOrders"
                :key="order.ordernumber"
                :ordernumber="order.ordernumber"
                :orderdate="order.orderdate"
                :orderstatus="order.orderstatus"
                :ordertotal="order.ordertotal"
              >
              </order-history-line>
            </tbody>
          </table>
        </div>
      </div>
      <div class="card-divider"></div>
      <div class="card-footer">
          <base-pagination
              :perPage="perPage"
              :pages="pages"
              :currentPage="page"
              @updatePage="updatePage">
          </base-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import axiosvl from "../../../axios/axios-vl.js";
import OrderHistoryLine from "./OrderHistoryLine.vue";
import BasePagination from "../../base/BasePagination.vue";

export default {
  components: {
    OrderHistoryLine,
    BasePagination
  },
  data() {
    return {
      orders: [],
      page: 1,
      perPage: 10,
      pages: []
    };
  },
  methods: {
      setPages () {
        let numberOfPages = Math.ceil(this.orders.length / this.perPage);
        for (let index = 1; index <= numberOfPages; index++) {
            this.pages.push(index);
        }
      },
      paginate (orders) {
        let page = this.page;
        let perPage = this.perPage;
        let from = (page * perPage) - perPage;
        let to = (page * perPage);

        return  orders.slice(from, to);
      },

      updatePage(currentPage) {
        this.page = currentPage;
      },
  },
  computed: {
      displayedOrders () {
          return this.paginate(this.orders);
      },
  },
  watch: {
      orders () {
          this.setPages();
      }
  },
   mounted() {
     const order_hist = this.$store.getters['api/order_history_uri'];
     // "/D15PGMLIB/lansaweb?w=OrderHist&r=Orders&vlweb=1&part=erp&lang=ENG&_T=1611072351543"
    axiosvl.post(order_hist, {
            "webroutine": {
                "context": {
                    "session-key-method": "hidden"
                },
                "fields": {
                    "EHCUST": {
                        "value": this.$store.getters.customer
                    }
                }
            }
        }
      )
      .then((response) => {
        const results = [];

        for (const key in response.data.webroutine.lists.LIST.entries) {
          const obj = response.data.webroutine.lists.LIST.entries[key];
          
          results.push({
            ordernumber: obj.XRORDNUM,
            location: obj.XRLOC,
            ponumber: obj.HACPONUM,
            LCNAME: obj.LCNAME,
            LCTAXC: obj.LCTAXC,
            orderdate: obj.ODRDATE,
            ordertotal: obj.TOLAMT,
            rrn: obj.PRIFILRRN,
            carrier: obj.XRCARR,
            HAQUOT: obj.HAQUOT,
            HATNTY: obj.HATNTY,
            orderstatus: obj.ORDERSTS,
            HICPONUM: obj.HICPONUM,
            HIINVNUM: obj.HIINVNUM,
          });
        }
        this.orders = results;
      })
      .catch(function (error) {
        console.log("error - " + error);
      });
   },
};
</script>